import { TemplateType } from 'compobot-dynamic-page';
import { CreateGuiVersionType } from 'types/compobotGuiVersion.type';

export const formDefaultValues: CreateGuiVersionType = {
  guiName: '',
  logoPath: '',
  compobotName: '',
  description: '',
  backgroundImage: '',
  qrCodeEn: '',
  qrCodeHu: '',
  pretextEn: '',
  pretextHu: '',
  titleEn: '',
  titleHu: '',
  subtitleEn: '',
  subtitleHu: '',
  from: '',
  to: '',
  templateType: TemplateType.THEME_01,
  language: 'en',
};

export const defaultColors = {
  pretext: '#2a6fe7ff',
  title: '#40d622ff',
  subtitle: '#bd2a2aff',
  overlay: '#3cb784',
};
